// extracted by mini-css-extract-plugin
module.exports = {"mainPage":"Staff_mainPage__2uxzk","body":"Staff_body__UUt_w","founderTitle":"Staff_founderTitle__1GNE3"};